export default __webpack_public_path__ + "static/media/before.ae5114fd.png";